import type { SVGProps } from 'react';

/**
 * Teivor monogram — `t` with the claret accent dot. Compact mark for the
 * collapsed rail / favicon contexts where the full wordmark won't fit. The
 * letter uses currentColor (ink, theme-adaptive); the dot uses the claret accent.
 * (The brand ships only a wordmark; this is the derived compact mark.)
 */
export function LogoMonogram(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 100 100"
      role="img"
      aria-label="Teivor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <text
        x="14"
        y="78"
        fontWeight="700"
        fontSize="84"
        letterSpacing="-0.04em"
        style={{ fontFamily: 'var(--tvl-font-ui), system-ui, sans-serif', fill: 'currentColor' }}
      >
        t
      </text>
      <circle cx="74" cy="74" r="10" style={{ fill: '#6E1423' }} />
    </svg>
  );
}
